<template>
  <div class="carrot">
    <div class="main-wrapper">
      <Menu></Menu>
      <pop-tutor-search
        :visible="popVisible"
        @pick="pick"
        @close="vueSeriesClose"
      />
      <pop-duplicated-search
        :target="popDupTarget"
        :word="popDupWord"
        :visible="popDupVisible"
        @pick="pickWord"
        @close="vueDuplicateClose"
      />
      <div class="page-wrapper">
        <div class="page-content ">
          <div class="row">
            <div class="col-xl-12">
              <h3 class="page-title">컨텐츠 수정</h3>
            </div>
          </div>
          <div class="row mt-20">
            <div class="col-md-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <div class="text-center">
                    <table class="table table-bordered">
                      <thead>
                        <!--                      <tr>
                        <th>화면 노출여부</th>
                        <td class="text-left">
                          <input v-model="video.displayStatus" type="radio" name="displayStatus" :value="null">미정
                          <input v-model="video.displayStatus" type="radio" name="displayStatus" value="A">로이터플랫폼에만 노출
                          <input v-model="video.displayStatus" type="radio" name="displayStatus" value="Y">모두 노출
                        </td>
                      </tr>
                      <tr>
                        <th>로이터 플랫폼 노출여부</th>
                        <td class="text-left">
                          <input v-model="video.isNrpaltform" type="radio" name="isNrpaltform" :value="null">미사용
                          <input v-model="video.isNrpaltform" type="radio" name="isNrpaltform" value="Y">사용
                        </td>
                      </tr>-->
                        <tr>
                          <th>컨텐츠 유형</th>
                          <td class="text-left">
                            <select
                              v-model="video.code"
                              name="cafe_code"
                              id="cafe_code"
                            >
                              <option
                                v-for="code in codes"
                                v-bind:key="code.idx"
                                v-bind:value="code.code"
                                >{{ code.name }}
                              </option>
                            </select>
                          </td>
                        </tr>
                        <tr>
                          <th>카테고리 선택</th>
                          <td class="text-left" style="white-space: inherit">
                            <div
                              v-for="category in categories"
                              :key="category.index"
                              style="line-height: 20px"
                            >
                              <input
                                type="checkbox"
                                v-model="selectedCategories"
                                :value="category.categoryCode"
                              />
                              {{ category.name }}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <th>레벨</th>
                          <td class="text-left">
                            {{ video.newLevel }}
                            <input
                              v-model="video.newsLevel"
                              type="radio"
                              name="level"
                              value="초급"
                            />
                            초급
                            <input
                              v-model="video.newsLevel"
                              type="radio"
                              name="level"
                              value="중급"
                            />
                            중급
                            <input
                              v-model="video.newsLevel"
                              type="radio"
                              name="level"
                              value="고급"
                            />
                            고급
                          </td>
                        </tr>
                        <tr>
                          <th>학습영역</th>
                          <td class="txt-left">
                            <select
                              v-model="video.studyArea"
                              name="study_area"
                              id="study_area"
                            >
                              <option value="">학습영역 선택</option>
                              <option value="회화">회화</option>
                              <option value="작문">작문</option>
                              <option value="청취">청취</option>
                              <option value="독해">독해</option>
                              <option value="문법">문법</option>
                              <option value="어휘">어휘</option>
                              <option value="발음">발음</option>
                            </select>
                          </td>
                        </tr>
                        <tr>
                          <th>인기도</th>
                          <td class="txt-left">
                            <select
                              v-model="video.hitCnt"
                              name="hit_cnt"
                              id="hit_cnt"
                            >
                              <option value="" selected="">인기도 선택</option>
                              <option value="5">5점</option>
                              <option value="4.5">4.5점</option>
                              <option value="4">4점</option>
                              <option value="3.5">3.5점</option>
                              <option value="3">3점</option>
                              <option value="2.5">2.5점</option>
                              <option value="2">2점</option>
                              <option value="1.5">1.5점</option>
                              <option value="1">1점</option>
                              ※최대 별 5개까지 인기도 표시를 할 수 있습니다.
                              (고객 화면에 별 갯수로 표시 됨)
                            </select>
                          </td>
                        </tr>
                      </thead>
                    </table>
                  </div>
                </div>

                <div class="card-body">
                  <div class="text-center">
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th>Tutor</th>
                          <td class="text-left">
                            <input type="hidden" v-model="tutor.regid" />
                            <input
                              type="text"
                              class="fl form-control w-20"
                              name="tutorNM"
                              v-model="video.writerName"
                            />
                            <!--<button class="btn btn-primary ml-10" @click="popVisible=true">강사검색</button>-->
                          </td>
                        </tr>
                        <tr>
                          <th>Date</th>
                          <td class="text-left">
                            <input
                              v-model="video.newsdate"
                              type="date"
                              class="form-control w-30"
                            />
                          </td>
                        </tr>
                        <tr>
                          <th><span class="red">*</span>동영상클립</th>
                          <td class="text-left">
                            <input
                              v-model="video.newsurl"
                              type="text"
                              class="form-control w-50"
                              name="tutorNM"
                            />
                          </td>
                        </tr>
                        <tr>
                          <th><span class="red">*</span>Mobile 주소</th>
                          <td class="text-left">
                            <input
                              v-model="video.mobileUrl"
                              type="text"
                              class="form-control w-50"
                              name="tutorNM"
                            />
                          </td>
                        </tr>
                        <tr>
                          <th><span class="red">*</span>이미지1</th>
                          <td class="text-left">
                            <upload-image
                              :img-style="'width:91px; height:91px;'"
                              :url="imageUrl"
                              :img="video.imgFile1"
                              @mountImage="video.imgFile1 = $event"
                            />
                            <!--등록된 파일 : {{ video.imgFile1 }}-->
                          </td>
                        </tr>
                        <tr>
                          <th><span class="red">*</span>이미지2</th>
                          <td class="text-left">
                            <upload-image
                              :img-style="'width:91px; height:91px;'"
                              :url="imageUrl"
                              :img="video.imgFile2"
                              @mountImage="video.imgFile2 = $event"
                            />
                            <!--등록된 파일 : {{ video.imgFile2 }}-->
                          </td>
                        </tr>
                        <tr>
                          <th>온라인카페 이미지 등록</th>
                          <td class="text-left">
                            <upload-image
                              :img-style="'width:91px; height:91px;'"
                              :url="imageUrl"
                              :img="video.imgFile3"
                              @mountImage="video.imgFile3 = $event"
                            />
                          </td>
                        </tr>
                        <tr>
                          <th>모바일 이미지등록</th>
                          <td class="text-left">
                            <upload-image
                              :img-style="'width:91px; height:91px;'"
                              :url="imageUrl"
                              :img="video.imgFile4"
                              @mountImage="video.imgFile4 = $event"
                            />
                          </td>
                        </tr>
                        <tr>
                          <th><span class="red">*</span>영문 Title</th>
                          <td class="txt-left">
                            <input
                              v-model="video.engTitle"
                              type="text"
                              class="form-control w-50"
                              placeholder="영문 Title"
                            />
                          </td>
                        </tr>
                        <tr>
                          <th><span class="red">*</span>한글 타이틀</th>
                          <td class="txt-left">
                            <input
                              v-model="video.korTitle"
                              type="text"
                              class="form-control w-50"
                              placeholder="한글 타이틀"
                            />
                          </td>
                        </tr>
                        <tr>
                          <th>Script</th>
                          <td class="txt-left">
                            <textarea
                              class="form-control h-200px"
                              v-model="video.newsScript"
                            ></textarea>
                          </td>
                        </tr>
                        <tr>
                          <th>script translation</th>
                          <td class="txt-left">
                            <textarea
                              class="form-control h-200px txt-area"
                              v-model="video.newsScriptTranslation"
                            ></textarea>
                          </td>
                        </tr>
                        <tr>
                          <th><span class="red">*</span>Key Vocabulary</th>
                          <td class="txt-left">
                            <table class="table table-bordered">
                              <tbody>
                                <tr>
                                  <td>
                                    <input
                                      v-model="vocabularies[0].word"
                                      class="fl form-control w-15"
                                      name="word1"
                                      type="text"
                                      id="word1"
                                      placeholder="영어단어"
                                    />
                                    <select
                                      class="fl w-20 ml-1"
                                      v-model="vocabularies[0].wordClass"
                                      name="word_class1"
                                      id="word_class1"
                                    >
                                      <option selected="">품사선택</option>
                                      <option value="noun">noun</option>
                                      <option value="verb">verb</option>
                                      <option value="adjective"
                                        >adjective</option
                                      >
                                      <option value="adverb">adverb</option>
                                      <option value="preposition"
                                        >preposition</option
                                      >
                                      <option value="gerund">gerund</option>
                                      <option value="article">article</option>
                                    </select>
                                    <input
                                      v-model="vocabularies[0].title"
                                      class="fl form-control w-35 ml-1"
                                      placeholder="한글 뜻"
                                      name="kv_title1"
                                      type="text"
                                      id="kv_title1"
                                      size="35"
                                    />
                                    <button
                                      @click="
                                        popDupShow(vocabularies[0].word, 0)
                                      "
                                      class="fl btn btn-primary ml-1"
                                    >
                                      중복검색
                                    </button>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <textarea
                                      class="form-control"
                                      v-model="vocabularies[0].content"
                                    >
예제문장 (한글해석 포함)</textarea
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <input
                                      v-model="vocabularies[1].word"
                                      class="fl form-control w-15"
                                      name="word1"
                                      type="text"
                                      id="word1"
                                      placeholder="영어단어"
                                    />
                                    <select
                                      class="fl w-20 ml-1"
                                      v-model="vocabularies[1].wordClass"
                                      name="word_class1"
                                      id="word_class1"
                                    >
                                      <option selected="">품사선택</option>
                                      <option value="noun">noun</option>
                                      <option value="verb">verb</option>
                                      <option value="adjective"
                                        >adjective</option
                                      >
                                      <option value="adverb">adverb</option>
                                      <option value="preposition"
                                        >preposition</option
                                      >
                                      <option value="gerund">gerund</option>
                                      <option value="article">article</option>
                                    </select>
                                    <input
                                      v-model="vocabularies[1].title"
                                      class="fl form-control w-35 ml-1"
                                      placeholder="한글 뜻"
                                      name="kv_title1"
                                      type="text"
                                      id="kv_title1"
                                      size="30"
                                    />
                                    <button
                                      @click="
                                        popDupShow(vocabularies[1].word, 1)
                                      "
                                      class="fl btn btn-primary ml-1"
                                    >
                                      중복검색
                                    </button>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <textarea
                                      class="form-control"
                                      v-model="vocabularies[1].content"
                                    >
예제문장 (한글해석 포함)</textarea
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <input
                                      v-model="vocabularies[2].word"
                                      class="fl form-control w-15"
                                      name="word1"
                                      type="text"
                                      id="word1"
                                      placeholder="영어단어"
                                    />
                                    <select
                                      class="fl w-20 ml-1"
                                      v-model="vocabularies[2].wordClass"
                                      name="word_class1"
                                      id="word_class1"
                                    >
                                      <option selected="">품사선택</option>
                                      <option value="noun">noun</option>
                                      <option value="verb">verb</option>
                                      <option value="adjective"
                                        >adjective</option
                                      >
                                      <option value="adverb">adverb</option>
                                      <option value="preposition"
                                        >preposition</option
                                      >
                                      <option value="gerund">gerund</option>
                                      <option value="article">article</option>
                                    </select>
                                    <input
                                      v-model="vocabularies[2].title"
                                      class="fl form-control w-35 ml-1"
                                      placeholder="한글 뜻"
                                      name="kv_title1"
                                      type="text"
                                      id="kv_title1"
                                      size="30"
                                    />
                                    <button
                                      @click="
                                        popDupShow(vocabularies[2].word, 2)
                                      "
                                      class="fl btn btn-primary ml-1"
                                    >
                                      중복검색
                                    </button>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <textarea
                                      class="form-control"
                                      v-model="vocabularies[2].content"
                                    >
예제문장 (한글해석 포함)</textarea
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <input
                                      v-model="vocabularies[3].word"
                                      class="fl form-control w-15"
                                      name="word1"
                                      type="text"
                                      id="word1"
                                      placeholder="영어단어"
                                    />
                                    <select
                                      class="fl w-20 ml-1"
                                      v-model="vocabularies[3].wordClass"
                                      name="word_class1"
                                      id="word_class1"
                                    >
                                      <option selected="">품사선택</option>
                                      <option value="noun">noun</option>
                                      <option value="verb">verb</option>
                                      <option value="adjective"
                                        >adjective</option
                                      >
                                      <option value="adverb">adverb</option>
                                      <option value="preposition"
                                        >preposition</option
                                      >
                                      <option value="gerund">gerund</option>
                                      <option value="article">article</option>
                                    </select>
                                    <input
                                      v-model="vocabularies[3].title"
                                      class="fl form-control w-35 ml-1"
                                      placeholder="한글 뜻"
                                      name="kv_title1"
                                      type="text"
                                      id="kv_title1"
                                      size="30"
                                    />
                                    <button
                                      @click="
                                        popDupShow(vocabularies[3].word, 3)
                                      "
                                      class="fl btn btn-primary ml-1"
                                    >
                                      중복검색
                                    </button>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <textarea
                                      class="form-control"
                                      v-model="vocabularies[3].content"
                                    >
예제문장 (한글해석 포함)</textarea
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <input
                                      v-model="vocabularies[4].word"
                                      class="fl form-control w-15"
                                      name="word1"
                                      type="text"
                                      id="word1"
                                      placeholder="영어단어"
                                    />
                                    <select
                                      class="fl w-20 ml-1"
                                      v-model="vocabularies[4].wordClass"
                                      name="word_class1"
                                      id="word_class1"
                                    >
                                      <option selected="">품사선택</option>
                                      <option value="noun">noun</option>
                                      <option value="verb">verb</option>
                                      <option value="adjective"
                                        >adjective</option
                                      >
                                      <option value="adverb">adverb</option>
                                      <option value="preposition"
                                        >preposition</option
                                      >
                                      <option value="gerund">gerund</option>
                                      <option value="article">article</option>
                                    </select>
                                    <input
                                      v-model="vocabularies[4].title"
                                      class="fl form-control w-35 ml-1"
                                      placeholder="한글 뜻"
                                      name="kv_title1"
                                      type="text"
                                      id="kv_title1"
                                      size="30"
                                    />
                                    <button
                                      @click="
                                        popDupShow(vocabularies[4].word, 4)
                                      "
                                      class="fl btn btn-primary ml-1"
                                    >
                                      중복검색
                                    </button>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <textarea
                                      class="form-control"
                                      v-model="vocabularies[4].content"
                                    >
예제문장 (한글해석 포함)</textarea
                                    >
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                        <tr>
                          <th><span class="red">*</span>Key Expressions</th>
                          <td class="txt-left">
                            <table class="table table-bordered">
                              <tbody>
                                <tr>
                                  <td>
                                    Expressions
                                    <input
                                      v-model="expressions[0].expressions"
                                      name="expressions1"
                                      type="text"
                                      id="expressions1"
                                      size="30"
                                    /><br/>
                                    한글 뜻
                                    <input
                                      v-model="expressions[0].korTitle"
                                      class="ml-35"
                                      name="ex_title1"
                                      type="text"
                                      id="ex_title1"
                                      size="30"
                                    />
                                    <img
                                      @click="
                                        pick4u(
                                          expressions[0].expressions,
                                          expressions[0].korTitle
                                        )
                                      "
                                      style="cursor: pointer; width: 46px; height: 18px; border-radius: 0%;"
                                      src="@/assets/img/pick_btn.png"
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <textarea
                                    class="form-control"
                                    v-model="expressions[0].content"
                                    name="ex_content1"
                                    id="ex_content1"
                                    rows="3"
                                  >
                                  </textarea>
                                </tr>
                                <tr>
                                  <td>
                                    Expressions
                                    <input
                                      v-model="expressions[1].expressions"
                                      name="expressions1"
                                      type="text"
                                      id="expressions2"
                                      size="30"
                                    /><br/>
                                    한글 뜻
                                    <input
                                      v-model="expressions[1].korTitle"
                                      class="ml-35"
                                      name="ex_title1"
                                      type="text"
                                      id="ex_title2"
                                      size="30"
                                    />
                                    <img
                                      @click="
                                        pick4u(
                                          expressions[1].expressions,
                                          expressions[1].korTitle
                                        )
                                      "
                                      style="cursor: pointer; width: 46px; height: 18px; border-radius: 0%;"
                                      src="@/assets/img/pick_btn.png"
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <textarea
                                    class="form-control"
                                    v-model="expressions[1].content"
                                    name="ex_content1"
                                    id="ex_content2"
                                    cols="90"
                                    rows="3"
                                  >
                                  </textarea>
                                </tr>
                                <tr>
                                  <td>
                                    Expressions
                                    <input
                                      v-model="expressions[2].expressions"
                                      name="expressions1"
                                      type="text"
                                      id="expressions3"
                                      size="30"
                                    /><br/>
                                    한글 뜻
                                    <input
                                      v-model="expressions[2].korTitle"
                                      class="ml-35"
                                      name="ex_title1"
                                      type="text"
                                      id="ex_title3"
                                      size="30"
                                    />
                                    <img
                                      @click="
                                        pick4u(
                                          expressions[2].expressions,
                                          expressions[2].korTitle
                                        )
                                      "
                                      style="cursor: pointer; width: 46px; height: 18px; border-radius: 0%;"
                                      src="@/assets/img/pick_btn.png"
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <textarea
                                    class="form-control"
                                    v-model="expressions[2].content"
                                    name="ex_content1"
                                    id="ex_content3"
                                    cols="90"
                                    rows="3"
                                  >
                                  </textarea>
                                </tr>
                                <tr>
                                  <td>
                                    Expressions
                                    <input
                                      v-model="expressions[3].expressions"
                                      name="expressions1"
                                      type="text"
                                      id="expressions4"
                                      size="30"
                                    /><br/>
                                    한글 뜻
                                    <input
                                      v-model="expressions[3].korTitle"
                                      class="ml-35"
                                      name="ex_title1"
                                      type="text"
                                      id="ex_title4"
                                      size="30"
                                    />
                                    <img
                                      @click="
                                        pick4u(
                                          expressions[3].expressions,
                                          expressions[3].korTitle
                                        )
                                      "
                                      style="cursor: pointer; width: 46px; height: 18px; border-radius: 0%;"
                                      src="@/assets/img/pick_btn.png"
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <textarea
                                    class="form-control"
                                    v-model="expressions[3].content"
                                    name="ex_content1"
                                    id="ex_content4"
                                    cols="90"
                                    rows="3"
                                  >
                                  </textarea>
                                </tr>
                                <tr>
                                  <td>
                                    Expressions
                                    <input
                                      v-model="expressions[4].expressions"
                                      name="expressions1"
                                      type="text"
                                      id="expressions5"
                                      size="30"
                                    /><br/>
                                    한글 뜻
                                    <input
                                      v-model="expressions[4].korTitle"
                                      class="ml-35"
                                      name="ex_title1"
                                      type="text"
                                      id="ex_title5"
                                      size="30"
                                    />
                                    <img
                                      @click="
                                        pick4u(
                                          expressions[4].expressions,
                                          expressions[4].korTitle
                                        )
                                      "
                                      style="cursor: pointer; width: 46px; height: 18px; border-radius: 0%;"
                                      src="@/assets/img/pick_btn.png"
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <textarea
                                    class="form-control"
                                    v-model="expressions[4].content"
                                    name="ex_content1"
                                    id="ex_content5"
                                    cols="90"
                                    rows="3"
                                  >
                                  </textarea>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                        <tr>
                          <th>
                            <span class="red">*</span>Comprehension Questions
                          </th>
                          <td class="txt-left">
                            <table class="table table-bordered">
                              <tbody>
                                <tr>
                                  <td>
                                    <input
                                      v-model="video.quizSort"
                                      type="radio"
                                      name="quiz_sort"
                                      value="1"
                                    />주관식
                                    <input
                                      v-model="video.quizSort"
                                      type="radio"
                                      name="quiz_sort"
                                      value="2"
                                    />객관식
                                  </td>
                                </tr>
                                <tr
                                  v-if="video.quizSort === '1'"
                                  id="div_quiz1"
                                >
                                  <td>
                                    <table
                                      border="0"
                                      cellspacing="0"
                                      cellpadding="2"
                                    >
                                      <tbody>
                                        <tr>
                                          <td>
                                            1. (Q)
                                            <input
                                              name="com_que1"
                                              type="text"
                                              v-model="qs[0].title"
                                              size="100%"
                                            /><br />
                                            1. (A)
                                            <input
                                              name="com_ans1"
                                              type="text"
                                              v-model="qs[0].answer"
                                              size="100%"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            2. (Q)
                                            <input
                                              name="com_que2"
                                              type="text"
                                              v-model="qs[1].title"
                                              size="100%"
                                            /><br />
                                            2. (A)
                                            <input
                                              name="com_ans2"
                                              type="text"
                                              v-model="qs[1].answer"
                                              size="100%"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            3. (Q)
                                            <input
                                              name="com_que3"
                                              type="text"
                                              v-model="qs[2].title"
                                              size="100%"
                                            /><br />
                                            3. (A)
                                            <input
                                              name="com_ans3"
                                              type="text"
                                              v-model="qs[2].answer"
                                              size="100%"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            4. (Q)
                                            <input
                                              name="com_que4"
                                              type="text"
                                              v-model="qs[3].title"
                                              size="100%"
                                            /><br />
                                            4. (A)
                                            <input
                                              name="com_ans4"
                                              type="text"
                                              v-model="qs[3].answer"
                                              size="100%"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            5. (Q)
                                            <input
                                              name="com_que5"
                                              type="text"
                                              v-model="qs[4].title"
                                              size="100%"
                                            /><br />
                                            5. (A)
                                            <input
                                              name="com_ans5"
                                              type="text"
                                              v-model="qs[4].answer"
                                              size="100%"
                                            />
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                                <tr
                                  v-if="video.quizSort === '2'"
                                  id="div_quiz2"
                                >
                                  <td>
                                    <table class="table table-bordered">
                                      <tbody>
                                        <tr>
                                          <td>
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.
                                            <input
                                              v-model="newQs[0].question"
                                              name="question1"
                                              type="text"
                                              size="100%"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <input
                                              v-model="newQs[0].answer"
                                              name="answer_1"
                                              type="radio"
                                              value="1"
                                            />
                                            a)
                                            <input
                                              v-model="newQs[0].exam1"
                                              name="exam1_1"
                                              type="text"
                                              size="100%"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <input
                                              v-model="newQs[0].answer"
                                              name="answer_1"
                                              type="radio"
                                              value="2"
                                            />
                                            b)
                                            <input
                                              v-model="newQs[0].exam2"
                                              name="exam2_1"
                                              type="text"
                                              size="100%"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <input
                                              v-model="newQs[0].answer"
                                              name="answer_1"
                                              type="radio"
                                              value="3"
                                            />
                                            c)
                                            <input
                                              v-model="newQs[0].exam3"
                                              name="exam3_1"
                                              type="text"
                                              size="100%"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2.
                                            <input
                                              v-model="newQs[1].question"
                                              name="question2"
                                              type="text"
                                              size="100%"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <input
                                              v-model="newQs[1].answer"
                                              name="answer_2"
                                              type="radio"
                                              value="1"
                                            />
                                            a)
                                            <input
                                              v-model="newQs[1].exam1"
                                              name="exam1_2"
                                              type="text"
                                              size="100%"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <input
                                              v-model="newQs[1].answer"
                                              name="answer_2"
                                              type="radio"
                                              value="2"
                                            />
                                            b)
                                            <input
                                              v-model="newQs[1].exam2"
                                              name="exam2_2"
                                              type="text"
                                              size="100%"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <input
                                              v-model="newQs[1].answer"
                                              name="answer_2"
                                              type="radio"
                                              value="3"
                                            />
                                            c)
                                            <input
                                              v-model="newQs[1].exam3"
                                              name="exam3_2"
                                              type="text"
                                              size="100%"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.
                                            <input
                                              v-model="newQs[2].question"
                                              name="question3"
                                              type="text"
                                              size="100%"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <input
                                              v-model="newQs[2].answer"
                                              name="answer_3"
                                              type="radio"
                                              value="1"
                                            />
                                            a)
                                            <input
                                              v-model="newQs[2].exam1"
                                              name="exam1_3"
                                              type="text"
                                              size="100%"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <input
                                              v-model="newQs[2].answer"
                                              name="answer_3"
                                              type="radio"
                                              value="2"
                                            />
                                            b)
                                            <input
                                              v-model="newQs[2].exam2"
                                              name="exam2_3"
                                              type="text"
                                              size="100%"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <input
                                              v-model="newQs[2].answer"
                                              name="answer_3"
                                              type="radio"
                                              value="3"
                                            />
                                            c)
                                            <input
                                              v-model="newQs[2].exam3"
                                              name="exam3_3"
                                              type="text"
                                              size="100%"
                                            />
                                          </td>
                                        </tr>
                                        <!--    <tr><td><input name="answer_3" type="radio" value="4"> d) <input name="exam4_3" type="text" size="80" ></td>
                                  </tr>  -->
                                        <tr>
                                          <td>
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4.
                                            <input
                                              v-model="newQs[3].question"
                                              name="question4"
                                              type="text"
                                              size="100%"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <input
                                              v-model="newQs[3].answer"
                                              name="answer_4"
                                              type="radio"
                                              value="1"
                                            />
                                            a)
                                            <input
                                              v-model="newQs[3].exam1"
                                              name="exam1_4"
                                              type="text"
                                              size="100%"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <input
                                              v-model="newQs[3].answer"
                                              name="answer_4"
                                              type="radio"
                                              value="2"
                                            />
                                            b)
                                            <input
                                              v-model="newQs[3].exam2"
                                              name="exam2_4"
                                              type="text"
                                              size="100%"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <input
                                              v-model="newQs[3].answer"
                                              name="answer_4"
                                              type="radio"
                                              value="3"
                                            />
                                            c)
                                            <input
                                              v-model="newQs[3].exam3"
                                              name="exam3_4"
                                              type="text"
                                              size="100%"
                                            />
                                          </td>
                                        </tr>
                                        <!--    <tr><td><input name="answer_4" type="radio" value="4"> d) <input name="exam4_4" type="text" size="80" ></td>
                                  </tr>  -->
                                        <tr>
                                          <td>
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5.
                                            <input
                                              v-model="newQs[4].question"
                                              name="question5"
                                              type="text"
                                              size="100%"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <input
                                              v-model="newQs[4].answer"
                                              name="answer_5"
                                              type="radio"
                                              value="1"
                                            />
                                            a)
                                            <input
                                              v-model="newQs[4].exam1"
                                              name="exam1_5"
                                              type="text"
                                              size="100%"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <input
                                              v-model="newQs[4].answer"
                                              name="answer_5"
                                              type="radio"
                                              value="2"
                                            />
                                            b)
                                            <input
                                              v-model="newQs[4].exam2"
                                              name="exam2_5"
                                              type="text"
                                              size="100%"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <input
                                              v-model="newQs[4].answer"
                                              name="answer_5"
                                              type="radio"
                                              value="3"
                                            />
                                            c)
                                            <input
                                              v-model="newQs[4].exam3"
                                              name="exam3_5"
                                              type="text"
                                              size="100%"
                                            />
                                          </td>
                                        </tr>
                                        <!--    <tr><td><input name="answer_5" type="radio" value="4"> d) <input name="exam4_5" type="text" size="80" ></td>
                                  </tr>  -->
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                        <tr>
                          <th>
                            <span class="red">*</span>Creative Discussion &
                            Writing
                          </th>
                          <td class="txt-left">
                            <table class="table table-bordered">
                              <tbody>
                                <tr>
                                  <td>
                                    1.
                                    <input
                                      name="cre_dis1"
                                      v-model="discussions[0].title"
                                      type="text"
                                      id="cre_dis1"
                                      size="100%"
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    2.
                                    <input
                                      name="cre_dis2"
                                      v-model="discussions[1].title"
                                      type="text"
                                      id="cre_dis2"
                                      size="100%"
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    3.
                                    <input
                                      name="cre_dis3"
                                      v-model="discussions[2].title"
                                      type="text"
                                      id="cre_dis3"
                                      size="100%"
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    4.
                                    <input
                                      name="cre_dis4"
                                      v-model="discussions[3].title"
                                      type="text"
                                      id="cre_dis4"
                                      size="100%"
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    5.
                                    <input
                                      name="cre_dis5"
                                      v-model="discussions[4].title"
                                      type="text"
                                      id="cre_dis5"
                                      size="100%"
                                    />
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                        <tr>
                          <th><span class="red">*</span>Active Dictation</th>
                          <td class="txt-left">
                            <span
                              >※빈칸으로 들어갈 단어를 { }로 표기해
                              주세요.</span
                            >

                            <span class="red">
                              ("{}"안에는 특수문자는 불가능합니다.)
                            </span>

                            <textarea
                              class="form-control h-200px mt-10 txt-area"
                              v-model="video.activeDictation"
                            ></textarea>
                          </td>
                        </tr>
                        <tr>
                          <th><span class="red">*</span>Speaking Training</th>
                          <td class="txt-left">
                            <table class="table table-bordered">
                              <tbody>
                                <tr>
                                  <td>
                                    ※Key expression이 포함된 문장 5개를 입력 해
                                    주세요.
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <table
                                      border="0"
                                      cellspacing="0"
                                      cellpadding="4"
                                      style="width:100%"
                                    >
                                      <tbody>
                                        <tr>
                                          <td width="20">1.</td>
                                          <td>
                                            <input
                                              type="text"
                                              name="aloud_title1"
                                              size="100%"
                                              style="width:100%"
                                              v-model="video.aloudTitle1"
                                            />
                                          </td>
                                        </tr>

                                        <tr>
                                          <td>2.</td>
                                          <td>
                                            <input
                                              type="text"
                                              name="aloud_title2"
                                              size="100%"
                                              style="width:100%"
                                              v-model="video.aloudTitle2"
                                            />
                                          </td>
                                        </tr>

                                        <tr>
                                          <td>3.</td>
                                          <td>
                                            <input
                                              type="text"
                                              name="aloud_title3"
                                              size="100%"
                                              style="width:100%"
                                              v-model="video.aloudTitle3"
                                            />
                                          </td>
                                        </tr>

                                        <tr>
                                          <td>4.</td>
                                          <td>
                                            <input
                                              type="text"
                                              name="aloud_title4"
                                              size="100%"
                                              style="width:100%"
                                              v-model="video.aloudTitle4"
                                            />
                                          </td>
                                        </tr>

                                        <tr>
                                          <td>5.</td>
                                          <td>
                                            <input
                                              type="text"
                                              name="aloud_title5"
                                              size="100%"
                                              style="width:100%"
                                              v-model="video.aloudTitle5"
                                            />
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                        <tr>
                          <th><span class="red">*</span>검색키워드</th>
                          <td class="txt-left">
                            <input
                              name="keyword"
                              type="text"
                              id="keyword"
                              size="100%"
                              style="width:100%"
                              value=""
                              v-model="video.keyword"
                            /><br />
                            ※해당 뉴스를 검색할 때 사용되는 키워드를
                            입력해주세요. (ex: 사과에 대한 뉴스-&gt; 사과,
                            apple, 과일, 빨간색 등..)<br />
                            ※여러개의 키워드를 입력하실 때 구분은 (,)로 해주시기
                            바랍니다. (ex: 영어, 단어, 공부)
                          </td>
                        </tr>
                        <tr>
                          <th>전화영어 Topic 이용여부</th>
                          <td class="text-left">
                            <input
                              v-model="video.callTopic"
                              type="radio"
                              name="call_topic"
                              value="Y"
                            />Y
                            <input
                              v-model="video.callTopic"
                              type="radio"
                              name="call_topic"
                              value="N"
                            />N
                          </td>
                        </tr>
                        <tr>
                          <th>글로벌존 메인 사용여부</th>
                          <td class="text-left">
                            <input
                              v-model="video.callMain"
                              type="radio"
                              name="call_main"
                              value="Y"
                            />Y
                            <input
                              v-model="video.callMain"
                              type="radio"
                              name="call_main"
                              value="N"
                            />N
                          </td>
                        </tr>
                        <tr>
                          <th>i:MOOC 발송 날짜</th>
                          <td class="text-left">
                            <input type="date" v-model="video.webzineDate" />
                          </td>
                        </tr>
                        <tr>
                          <th>당근농장(통합플랫폼) 노출여부</th>
                          <td class="text-left">
                            <input
                              v-model="video.isFarm"
                              type="radio"
                              name="is_farm"
                              value="Y"
                            />Y
                            <input type="date" v-model="video.isFarmdate" />
                            <input
                              v-model="video.isFarm"
                              type="radio"
                              name="is_farm"
                              value="N"
                            />N
                          </td>
                        </tr>
                        <tr>
                          <th>추천메일 발송 날짜</th>
                          <td class="txt-left">
                            <input
                              type="date"
                              v-model="video.guestWebzineDate"
                            />
                          </td>
                        </tr>
                      </thead>
                    </table>
                  </div>
                  <button
                    class="fr ml-1 mt-2 btn btn-primary"
                    @click="putVideo()"
                  >
                    수정
                  </button>
                  <span v-if="video.displayStatus === 'N'">
                    <button
                      class="fr ml-1 mt-2 btn btn-primary"
                      @click="goEnd()"
                    >
                      최종작성완료(당근영어)
                    </button>
                    <button class="fr mt-2 btn btn-primary" @click="goEndRP()">
                      최종작성완료(로이터 플랫폼에만 노출)
                    </button>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from "../../components/commons/incMenu";
import PopTutorSearch from "../../components/popTutorSearch";
import PopDuplicatedSearch from "../../components/popDulicatedSerach";
import UploadImage from "../../components/upload/uploadImage";

export default {
  name: "videoAdd",
  components: {
    Menu,
    PopTutorSearch,
    PopDuplicatedSearch,
    UploadImage
  },
  mounted() {
    this.selectVideoOne();
    this.selectCategories();
    this.selectCodes();
    let userAgent = window.navigator.userAgent;
    if (
      userAgent.indexOf("iPhone") !== -1 ||
      userAgent.indexOf("iPod") !== -1 ||
      userAgent.indexOf("iPad") !== -1
    ) {
      this.agent = "ios";
    } else if (userAgent.indexOf("Android") !== -1) {
      this.agent = "Android";
    } else {
      this.agent = "pc";
    }
  },
  data: () => ({
    imgOriginUrl: "https://kr.object.ncloudstorage.com/reuters/image/",
    video: {},
    tutor: {},
    vocabularies: [
      {
        content: null,
        newsSeq: null,
        seq: null,
        title: null,
        word: null,
        wordClass: null
      },
      {
        content: null,
        newsSeq: null,
        seq: null,
        title: null,
        word: null,
        wordClass: null
      },
      {
        content: null,
        newsSeq: null,
        seq: null,
        title: null,
        word: null,
        wordClass: null
      },
      {
        content: null,
        newsSeq: null,
        seq: null,
        title: null,
        word: null,
        wordClass: null
      },
      {
        content: null,
        newsSeq: null,
        seq: null,
        title: null,
        word: "",
        wordClass: null
      }
    ],
    newQs: [
      {
        answer: null,
        exam1: null,
        exam2: null,
        exam3: null,
        exam4: null,
        newsSeq: null,
        question: null,
        rdate: null,
        seq: null
      },
      {
        answer: null,
        exam1: null,
        exam2: null,
        exam3: null,
        exam4: null,
        newsSeq: null,
        question: null,
        rdate: null,
        seq: null
      },
      {
        answer: null,
        exam1: null,
        exam2: null,
        exam3: null,
        exam4: null,
        newsSeq: null,
        question: null,
        rdate: null,
        seq: null
      },
      {
        answer: null,
        exam1: null,
        exam2: null,
        exam3: null,
        exam4: null,
        newsSeq: null,
        question: null,
        rdate: null,
        seq: null
      },
      {
        answer: null,
        exam1: null,
        exam2: null,
        exam3: null,
        exam4: null,
        newsSeq: null,
        question: null,
        rdate: null,
        seq: null
      }
    ],
    qs: [
      {
        answer: null,
        title: null,
        seq: null,
        newsSeq: null
      },
      {
        answer: null,
        title: null,
        seq: null,
        newsSeq: null
      },
      {
        answer: null,
        title: null,
        seq: null,
        newsSeq: null
      },
      {
        answer: null,
        title: null,
        seq: null,
        newsSeq: null
      },
      {
        answer: null,
        title: null,
        seq: null,
        newsSeq: null
      }
    ],
    expressions: [
      {
        content: null,
        expressions: null,
        korTitle: null,
        newsSeq: null,
        seq: null
      },
      {
        content: null,
        expressions: null,
        korTitle: null,
        newsSeq: null,
        seq: null
      },
      {
        content: null,
        expressions: null,
        korTitle: null,
        newsSeq: null,
        seq: null
      },
      {
        content: null,
        expressions: null,
        korTitle: null,
        newsSeq: null,
        seq: null
      },
      {
        content: null,
        expressions: null,
        korTitle: null,
        newsSeq: null,
        seq: null
      }
    ],
    discussions: [
      {
        seq: null,
        newsSeq: null,
        title: null
      },
      {
        seq: null,
        newsSeq: null,
        title: null
      },
      {
        seq: null,
        newsSeq: null,
        title: null
      },
      {
        seq: null,
        newsSeq: null,
        title: null
      },
      {
        seq: null,
        newsSeq: null,
        title: null
      }
    ],
    categories: [],
    codes: [],
    selectedCategories: [],
    popVisible: false,
    popDupVisible: false,
    popDupWord: "",
    popDupTarget: 0,
    imageUrl: "https://reuters-api.carrotenglish.com/v1/api/admin/videos/image",
    agent: "pc"
  }),
  computed: {},
  methods: {
    goEnd: function() {
      const url = "/v1/api/admin/goEnd";
      const body = {
        seq: this.video.newsSeq
      };
      this.axios.put(url, body).then(res => {
        console.log(res);
        alert("수정이 완료되었습니다.");
        this.$router.push("/videos");
      });
    },
    goEndRP: function() {
      const url = "/v1/api/admin/goEndRP";
      const body = {
        seq: this.video.newsSeq
      };
      this.axios.put(url, body).then(res => {
        console.log(res);
        alert("수정이 완료되었습니다.");
        this.$router.push("/videos");
      });
    },
    pick4u: function(expressions, kor) {
      console.log(expressions, kor);
      if (expressions != null && kor != null) {
        if(this.agent == 'ios') {
          window.location.href = "https://imooc.co.kr/pop/reuter_pick?key=" + expressions + "&kor_title=" + kor, "P!ck.4.U", "status=no, height=" + 800 +", width=" +700 +", left=" +500 +", top=" +500;
        }
        else {
          window.open(
          "https://imooc.co.kr/pop/reuter_pick?key=" +
            expressions + "&kor_title=" + kor, "P!ck.4.U", "status=no, height=" + 800 +", width=" +700 +", left=" +500 +", top=" +500);
        }
      } else {
        alert("expressions 혹은 한글 뜻을 입력해주세요.");
      }
    },
    popDupShow: function(word, num) {
      this.popDupWord = word;
      this.popDupVisible = true;
      this.popDupTarget = num;
    },
    vueDuplicateClose: function(state) {
      this.popDupVisible = state;
    },
    vueSeriesClose: function(state) {
      this.popVisible = state;
    },
    pick: function(tutor) {
      this.tutor = tutor;
    },
    pickWord: function(word) {
      this.vocabularies[this.popDupTarget] = word;
    },

    validate: function() {
      let bool = false;
      if (this.video.code === null || this.video.code === "") {
        alert("컨텐츠 유형을 반드시 선택해주시기 바랍니다.");
      } else if (this.video.newsLevel === null || this.video.newsLevel === "") {
        alert("레벨을 반드시 선택해주시기 바랍니다.");
      } else if (this.video.studyArea === null || this.video.studyArea === "") {
        alert("학습영역을 반드시 선택해주시기 바랍니다.");
      } else if (this.video.hitCnt === null || this.video.hitCnt === "") {
        alert("인기도를 반드시 선택해주시기 바랍니다.");
      } else if (this.video.newsdate === null || this.video.newsdate === "") {
        alert("Date를 반드시 선택해주시기 바랍니다.");
      } else if (this.video.newsurl === null || this.video.newsurl === "") {
        alert("동영상 클립을 반드시 입력해주시기 바랍니다.");
      } else if (this.video.mobileUrl === null || this.video.mobileUrl === "") {
        alert("Mobile 주소를 반드시 입력해주시기 바랍니다.");
      } else if (this.video.img1 === null || this.video.img1 === "") {
        alert("이미지를 입력해주시기 바랍니다.");
      } else if (this.video.img2 === null || this.video.img2 === "") {
        alert("이미지를 입력해주시기 바랍니다.");
      } else if (this.video.engTitle === null || this.video.engTitle === "") {
        alert("영문타이틀을 반드시 입력해주시기 바랍니다.");
      } else if (this.video.korTitle === null || this.video.korTitle === "") {
        alert("국문타이틀을 반드시 입력해주시기 바랍니다.");
      } else if (
        this.video.isFarm === "Y" &&
        (this.video.isFarmdate === null || this.video.isFarmdate === "")
      ) {
        alert("당근농장 노출여부 날짜 입력해주시기 바랍니다.");
      } /*else if (this.video.isFarm === 'Y' && this.video.isFarmdate < this.$moment().format('YYYY-MM-DD')) {
        alert('당근농장 노출여부 날짜는 오늘보다 이전 날짜 설정이 불가능합니다.')
      } */ else {
        bool = true;
      }

      return bool;
    },
    putVideo: function() {
      const url = "/v1/api/admin/videos";
      if (this.validate()) {
        const body = {
          movieNews: this.video,
          tutor: this.tutor,
          vocabularies: this.vocabularies.slice(0, 5),
          newQs: this.newQs.slice(0, 5),
          qs: this.qs.slice(0, 5),
          expressions: this.expressions.slice(0, 5),
          discussions: this.discussions.slice(0, 5),
          selectCategories: this.selectedCategories
        };
        console.log(body);
        this.axios.put(url, body).then(res => {
          console.log(res);
          alert("수정이 완료되었습니다.");
          this.$router.push("/videos");
        });
      }
    },
    selectCodes: function() {
      const url = "/v1/api/admin/codes";
      this.axios
        .get(url)
        .then(res => {
          if (res.data.err === 0) {
            console.log(res.data.codes);
            this.codes = res.data.codes;
          }
        })
        .catch(err => {
          if (err.response.data.path === "/login/msg") {
            alert("세션이 끊어졌습니다. 로그인 페이지로 이동합니다.");
            this.$router.push("/login");
          } else {
            alert("관리자에게 문의하세요");
          }
        });
    },
    selectCategories: function() {
      const url = "/v1/api/admin/category";
      this.axios
        .get(url)
        .then(res => {
          if (res.data.err === 0) {
            console.log(res.data.categories);
            this.categories = res.data.categories;
          }
        })
        .catch(err => {
          if (err.response.data.path === "/login/msg") {
            alert("세션이 끊어졌습니다. 로그인 페이지로 이동합니다.");
            this.$router.push("/login");
          } else {
            alert("관리자에게 문의하세요");
          }
        });
    },
    selectVideoOne: function() {
      const url = "/v1/api/admin/videos/" + this.$route.params.idx;
      this.axios
        .get(url)
        .then(res => {
          console.log(res);
          if (res.data.err === 0) {
            if (res.data.videos != null) {
              this.video = res.data.videos;
            }
            if (res.data.tutor != null) {
              this.tutor = res.data.tutor;
            }
            if (res.data.expressions.length > 0) {
              this.expressions = res.data.expressions.concat(this.expressions);
            }
            if (res.data.vocabularies.length > 0) {
              this.vocabularies = res.data.vocabularies;
            }
            if (res.data.qs.length > 0) {
              this.qs = res.data.qs.concat(this.qs);
            }
            if (res.data.newQs.length > 0) {
              this.newQs = res.data.newQs.concat(this.newQs);
            }
            if (res.data.discussions.length > 0) {
              this.discussions = res.data.discussions.concat(this.discussions);
            }

            if (this.video.createdate != null) {
              this.video.createdate = this.video.createdate.substring(0, 10);
            }

            if (res.data.selectedCategories.length > 0) {
              this.selectedCategories = res.data.selectedCategories.map(
                (value, index) => {
                  return value.categorySeq;
                }
              );
            }
          }
        })
        .catch(err => {
          console.log(err);
          if (err.response.data.path === "/login/msg") {
            alert("세션이 끊어졌습니다. 로그인 페이지로 이동합니다.");
            this.$router.push("/login");
          } else {
            alert("관리자에게 문의하세요");
          }
        });
    }
  }
};
</script>
<style>
@import "../../../src/assets/scss/style.css";
@import "../../../src/assets/scss/commons/_style.css";
@import "../../../src/assets/scss/commons/_carrot.css";

.fw-bold {
  font-weight: bold;
}

.txt-area {
  line-height: 1.5em;
}
.ml-35 {
  margin-left : 34px;
  margin-top : 1px;
}
</style>



// WEBPACK FOOTER //
// src/pages/videos/videoModify.vue